import { z } from 'zod';

export const BidSchema = z.object({
  uid: z.string(),
  username: z.string(),
  offer_id: z.string(),
  product_id: z.string(),
  bid_price: z.number(),
  max_bid: z.number().optional(),
  created: z.number().default(() => Date.now()),
  id: z.string().optional(),
  auto: z.boolean().optional().default(false),
});

export type BidDocument = z.infer<typeof BidSchema>;
